import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/player-position-stacking/actions';
import ForceSecondaryStack from './force-secondary-stack';
import AllowOverlapPrimaryAndSecondaryStacks from './allow-overlap-primary-and-secondary-stacks';
import InputRadio from 'components/atoms/inputs/input-radio';

class SecondaryStackType extends Component {
    onSelect(isChecked) {
        this.props.dispatch(Action.do('useSecondaryStack', isChecked));
    }

    render() {
        const {stacking} = this.props;

        return (
            <div className="form-inline">
                <div className="form-text">Secondary Stack:</div>
                <InputRadio
                    label="Off"
                    checked={!stacking.isSecondaryStackUsed()}
                    onChange={() => this.onSelect(false)}
                />
                <InputRadio
                    label="On"
                    checked={stacking.isSecondaryStackUsed()}
                    onChange={() => this.onSelect(true)}
                />
                {stacking.isSecondaryStackUsed()
                ? (
                    <>
                        <ForceSecondaryStack />
                        {/* <AllowOverlapPrimaryAndSecondaryStacks /> */}
                    </>
                )
                : null}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerPositionStacking} = state;

    return {
        stacking: playerPositionStacking,
    };
}

export default connect(mapStatesToProps)(SecondaryStackType);
